import { render } from "./SvgChannelPointsRounded.vue?vue&type=template&id=3f32ae0e&ts=true"
import script from "./SvgChannelPointsRounded.vue?vue&type=script&lang=ts"
export * from "./SvgChannelPointsRounded.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__